import axios from '../../../axios';
import IJobBoard from '../../JobBoardService/types/IJobBoard';
import ITechFetchJobPostingDTO from '../types/ITechFetchJobPostingDTO';

const url = '/jobsearch/api/tech-fetch';

export const postToTechFetch = (techFetchJobPosting: ITechFetchJobPostingDTO) =>
  axios.post(`${url}`, techFetchJobPosting);

export const deleteJobFromTechFetch = (jobId: string, email: string) =>
  axios.delete(`${url}/${jobId}/${email}`);

export const getTechFetchJobPostingUsageReport = (jobBoard: IJobBoard) =>
  axios.post(`${url}/get-usage-report`, jobBoard);
